import { FunctionComponent } from "react";
import ProtocolLayout from "../components/ProtocolLayout";

interface LinkedInBannerProps {}

const LinkedInBanner: FunctionComponent<LinkedInBannerProps> = () => {
  return (
    <ProtocolLayout>
      <div className="flex flex-col items-center py-12">
        <div className="mb-12 text-3xl font-bold underline">
          LinkedIn Banner
        </div>
        <div className="grid lg:grid-cols-3 justify-items-center gap-y-5 lg:gap-y-0 w-4/5 mt-6 lg:mt-20">
          <a
            href="https://drive.google.com/file/d/1-3_TiZtSGi8XiY0F5nShzbaYyxyJ9FyI/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            <div className="relative bg-gray-100 hover:bg-gray-200 duration-300 w-72 h-64 flex flex-col items-center justify-center rounded-xl shadow-lg py-12 px-4 ">
              <div className="">
                {/* <img src="/docs/gmc1.png" alt="" className="w-32" /> */}
              </div>
              <div className="mt-12 text-black text-opacity-40 font-bold text-xl">
                LinkedIn Banner 1
              </div>
            </div>
          </a>
          <a
            href="https://drive.google.com/file/d/14MGWwzHEmbDu2vdV1ZoK34aHxNwvk0z4/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            <div className="relative bg-gray-100 hover:bg-gray-200 duration-300 w-72 h-64 flex flex-col items-center justify-center rounded-xl shadow-lg py-12 px-4 ">
              <div className="">
                {/* <img src="/docs/gmc1.png" alt="" className="w-32" /> */}
              </div>
              <div className="mt-12 text-black text-opacity-40 font-bold text-xl">
                LinkedIn Banner 2
              </div>
            </div>
          </a>
          <a
            href="https://drive.google.com/file/d/1ABgATx3MgLYA0NyZADXN1cP4nZ8Tn2_j/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            <div className="relative bg-gray-100 hover:bg-gray-200 duration-300 w-72 h-64 flex flex-col items-center justify-center rounded-xl shadow-lg py-12 px-4 ">
              <div className="">
                {/* <img src="/docs/gmc1.png" alt="" className="w-32" /> */}
              </div>
              <div className="mt-12 text-black text-opacity-40 font-bold text-xl">
                LinkedIn Banner 3
              </div>
            </div>
          </a>
        </div>
        <div className="grid lg:grid-cols-3 justify-items-center gap-y-5 lg:gap-y-0 w-4/5 mt-6 lg:mt-20">
          <a
            href="https://drive.google.com/file/d/1DyzyHcj6lK_jwT9IqdakVk5SOmrJec7O/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            <div className="relative bg-gray-100 hover:bg-gray-200 duration-300 w-72 h-64 flex flex-col items-center justify-center rounded-xl shadow-lg py-12 px-4 ">
              <div className="">
                {/* <img src="/docs/gmc1.png" alt="" className="w-32" /> */}
              </div>
              <div className="mt-12 text-black text-opacity-40 font-bold text-xl">
                LinkedIn Banner 4
              </div>
            </div>
          </a>
        </div>
      </div>
    </ProtocolLayout>
  );
};

export default LinkedInBanner;
